module.exports = __webpack_public_path__ + "static/media/logo-master.fb721fd3.png";